import { Button, Card } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers } from '../../../context/page-context';

export function ExploreCard() {
  const { navigationHandler } = useHandlers();

  return (
    <Card>
      <Card.Header icon="view" headingLevel="h2">
        {t('features:home.components.explore_card.title')}
      </Card.Header>
      <Card.Body justifyBetween>
        {t('features:home.components.explore_card.description')}
        <Button variant="secondary" onClick={() => navigationHandler.navigateById('features')}>
          {t('features:home.components.explore_card.action')}
        </Button>
      </Card.Body>
    </Card>
  );
}
